import { useTranslation } from "react-i18next";
import Icon from "../../controls/Icon";
import { getSafe } from "../../util/storeHelper";
import React from "react";
import * as ReactDOM from "react-dom";
import { MenuItem } from "react-bootstrap";
import { useSelector, useStore } from "react-redux";
import Dropdown from "../../controls/Dropdown";
import PortalMenu from "../../controls/PortalMenu";
import { setToolVisible } from "../gamemode_management/actions/settings";
import * as selectors from "../../util/selectors";
export default function AddToolButton(props) {
    const [t] = useTranslation();
    const { gameMode, discoveredTools, toolsOrder } = useSelector(mapStateToProps);
    const { tools, onAddNewTool, onSetToolOrder } = props;
    const store = useStore();
    const hidden = tools.filter((starter) => discoveredTools[starter.id] !== undefined &&
        discoveredTools[starter.id].hidden === true);
    const dropRef = React.useRef();
    const [open, setOpen] = React.useState(false);
    const setToolOrder = React.useCallback((newOrder) => {
        onSetToolOrder(newOrder);
    }, [onSetToolOrder]);
    const addNewTool = React.useCallback((e) => {
        onAddNewTool();
    }, [onAddNewTool]);
    React.useEffect(() => {
        const hiddenIds = Object.values(hidden).map((tool) => tool.id);
        const newOrder = toolsOrder.reduce((prev, iter) => {
            if (!hiddenIds.includes(iter)) {
                prev.push(iter);
            }
            return prev;
        }, []);
        if (hidden.length !== newOrder.length) {
            setToolOrder(newOrder);
        }
    }, [discoveredTools]);
    const unhide = React.useCallback((key) => {
        store.dispatch(setToolVisible(gameMode, key, true));
    }, [store]);
    const classes = ["btn-add-tool"];
    if (tools.length - hidden.length > 3) {
        classes.push("dropup");
    }
    if (gameMode === undefined) {
        return null;
    }
    const setRef = (ref) => {
        dropRef.current = ReactDOM.findDOMNode(ref);
    };
    const onToggleOpen = React.useCallback(() => {
        setOpen(true);
    }, [setOpen]);
    const onToggleClose = React.useCallback(() => {
        setOpen(false);
    }, [setOpen]);
    return (React.createElement(Dropdown, { id: "add-tool-button-menu", className: classes.join(" "), ref: setRef },
        React.createElement(Dropdown.Toggle, { noCaret: true, className: "btn-add-tool-dropdown-toggle", open: open, onClick: onToggleOpen },
            React.createElement(Icon, { name: "add", className: "btn-add-tool-icon" }),
            React.createElement("div", { className: "btn-add-tool-text" }, t("Add Tool"))),
        React.createElement(PortalMenu, { onClick: nop, onClose: onToggleClose, open: open, target: dropRef.current, bsRole: "menu" },
            hidden.map((starter) => (React.createElement(MenuItem, { key: starter.id, eventKey: starter.id, onSelect: unhide }, starter.name))),
            React.createElement(MenuItem, { key: "__add", onSelect: addNewTool }, t("New...")))));
}
const emptyObj = {};
function mapStateToProps(state) {
    const game = selectors.currentGame(state);
    if (game?.id === undefined) {
        return {
            gameMode: undefined,
            toolsOrder: [],
            discoveredTools: emptyObj,
            primaryTool: undefined,
        };
    }
    return {
        gameMode: game.id,
        toolsOrder: getSafe(state, ["settings", "interface", "tools", "order", game.id], []),
        discoveredTools: getSafe(state, ["settings", "gameMode", "discovered", game.id, "tools"], emptyObj),
        primaryTool: getSafe(state, ["settings", "interface", "primaryTool", game.id], undefined),
    };
}
function nop() {
    // nop
}
